exports.components = {
  "component---src-pages-darkovepukazy-js": () => import("./../../../src/pages/darkovepukazy.js" /* webpackChunkName: "component---src-pages-darkovepukazy-js" */),
  "component---src-pages-english-js": () => import("./../../../src/pages/english.js" /* webpackChunkName: "component---src-pages-english-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kosmetika-js": () => import("./../../../src/pages/kosmetika.js" /* webpackChunkName: "component---src-pages-kosmetika-js" */),
  "component---src-pages-masaze-js": () => import("./../../../src/pages/masaze.js" /* webpackChunkName: "component---src-pages-masaze-js" */)
}

